<mat-radio-group [(ngModel)]="selected" (change)="handleOnChange($event)">
  @for (option of options; track option) {
    <app-input-radio [value]="option.value" [label]="option.label" />
  }
</mat-radio-group>
